import { HttpHeaders } from '../../interceptor/interfaces';
const isRangeRequest = (headers: HttpHeaders): boolean => {
  for (const key of headers.keys()) {
    if (key.localeCompare('range', 'en', { sensitivity: 'base' }) == 0) {
      return true;
    }
  }
  return false;
};
export default isRangeRequest;
